import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Menu, ChevronDown } from 'lucide-react';
import Grievance from './pages/Grievance';
import Home from './pages/Home';
import logo from "../src/assets/images/logo.jpg";
import Anti from './pages/comitties/Anti';
import Iqac from './pages/comitties/Iqac';
import Development from './pages/comitties/Development';
import Administrative from './pages/comitties/Administrative';
import Diyang from './pages/comitties/Diyang';
import Statutory from './pages/comitties/Statutory';
import Student from './pages/comitties/Student';
import Admission from './pages/comitties/Admission';
import Womens from './pages/comitties/Womens';
import Equal from './pages/comitties/Equal';
import Contact from './pages/Contact';
import Photo from "../src/assets/images/background.jpg";
import Scholership from './pages/Scholership';
import Startup from './pages/Startup';
import Learn from './pages/Learn';
import EarnAndLearn from './pages/Learn';
import "../src/App.css"
import Government from './pages/comitties/Government';
function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const closeMenu = (e) => {
    if (e.target.id === "menuOverlay") {
      setMenuOpen(false);
    }
  };

  return (
    <Router>
      {/* Background Section */}
      <div className='relative w-full h-screen'>


        {/* Menu Button */}
        <header className='w-full flex justify-between items-center p-4 bg-white shadow-md relative z-10'>
          <div className='text-2xl font-bold text-blue-600 flex flex-row gap-2 items-center'>
            <img src={logo} alt='Arya Senior College' className='h-14' />
            <h2 className='font-serif text-[#000] text-xl'>Arya Senior College, Manjari</h2>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              setMenuOpen(!menuOpen);
            }}
            className="p-2 text-white rounded-lg shadow-md bg-[#821232] hover:bg-blue-100 transition duration-300 ease-in-out animate-blink"
          >
            About Us
          </button>

        </header>

        {/* Sidebar Menu */}
        {menuOpen && (
          <div className='fixed inset-0 bg-black bg-opacity-30 z-50' id='menuOverlay'>
            <nav className='fixed top-0 right-0 w-64 h-full bg-white shadow-lg p-4 flex flex-col z-50'>
              <Link to='/' className='mb-2 text-lg text-[#000] no-underline' onClick={() => setMenuOpen(false)}>Home</Link>
              <Link to='/learn-and-earn-scheme' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Learn & Earn Scheme</Link>
              {/* Dropdown */}
              <div>
                <button className='flex items-center justify-between w-full text-lg text-[#000]' onClick={() => setSubmenuOpen(!submenuOpen)}>
                  Committies <ChevronDown size={18} className={`transition-transform ${submenuOpen ? 'rotate-180' : ''}`} />
                </button>
                {submenuOpen && (
                  <div className='ml-4 mt-2 flex flex-col'>
                    <Link to='/anti-ragging-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Anti Ragging Cell</Link>
                    <Link to='/grievance-redressal-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Grievance Redressal Cell</Link>
                    <Link to='/iqac-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>IQAC (Internal Quality Assurance Cell) Cell</Link>
                    <Link to='/college-development-committe' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>College Development Committe</Link>
                    <Link to='/administrative-committe' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Administrative Committe</Link>
                    <Link to='/admission-committe' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Admission Committe</Link>
                    <Link to='/satutory-committe' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Satutory Committe</Link>
                    <Link to='/equal-opportunity-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Equal Opportunity Cell</Link>
                    <Link to='/diyang-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Diyang Cell</Link>
                    <Link to='/womens-anti-sexual-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Womens Anti-Sexual Harassment Cell</Link>
                    <Link to='/student-council' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Student Council</Link>
                    <Link to='/startup-and-innovation-cell' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Startup & Innovation Cell</Link>
                    <Link to='/government-body' className='text-[#000] py-1 no-underline' onClick={() => setMenuOpen(false)}>Government Body</Link>
                  </div>
                )}
              </div>
              <p className='pt-2 text-gray-400'>Notice & Circulers</p>
              <Link to='/scholership' className='bg-green-400 text-white p-2 rounded no-underline' onClick={() => setMenuOpen(false)}>SCHOLERSHIP</Link>

              <Link to='/grievance-redressal-cell' className='text-lg text-[#000] mt-2 no-underline' onClick={() => setMenuOpen(false)}>Grievance</Link>
              <Link to='/contact-us' className='text-lg text-[#000] mt-2 no-underline' onClick={() => setMenuOpen(false)}>Contact Us</Link>
            </nav>
          </div>
        )}

        {/* Routes */}
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/anti-ragging-cell' element={<Anti />} />
          <Route path='/grievance-redressal-cell' element={<Grievance />} />
          <Route path='/iqac-cell' element={<Iqac />} />
          <Route path='/college-development-committe' element={<Development />} />
          <Route path='/administrative-committe' element={<Administrative />} />
          <Route path='/admission-committe' element={<Admission />} />
          <Route path='/satutory-committe' element={<Statutory />} />
          <Route path='/equal-opportunity-cell' element={<Equal />} />
          <Route path='/diyang-cell' element={<Diyang />} />
          <Route path='/womens-anti-sexual-cell' element={<Womens />} />
          <Route path='/student-council' element={<Student />} />
          <Route path='/contact-us' element={<Contact />} />

          <Route path='/government-body' element={<Government />} />


          <Route path='/scholership' element={<Scholership />} />
          <Route path='/startup-and-innovation-cell' element={<Startup />} />
          <Route path='/learn-and-earn-scheme' element={<EarnAndLearn />} />
        </Routes>
      </div>

    </Router>
  );
}

export default App;
